import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './DestinationSelector.css';
const DestinationSelector = ({ 
  postDestination, 
  setPostDestination, 
  userGroups, 
  userPages, 
  selectedGroup, 
  setSelectedGroup, 
  selectedPage, 
  setSelectedPage,
  setIsScheduledPost 
}) => {
  const handleDestinationChange = (value) => {
    setPostDestination(value);
    setSelectedGroup(null);
    setSelectedPage(null);
    setIsScheduledPost(false); // Reset programmation si on change de destination
  };

  return (
    <div className="ds-container">
      <select 
        className="ds-select"
        value={postDestination}
        onChange={(e) => handleDestinationChange(e.target.value)}
      >
        <option value="wall">Mon mur</option>
        {userPages.length > 0 && <option value="page">Page</option>}
        {userGroups.length > 0 && <option value="group">Groupe</option>}
      </select>
      
      {postDestination === "page" && userPages.length > 0 && (
        <select 
          className="ds-target-select"
          value={selectedPage || ""}
          onChange={(e) => setSelectedPage(e.target.value)}
        >
          <option value="">Choisir une page</option>
          {userPages.map(page => (
            <option key={page.page_id} value={page.page_id}>
              {page.page_title || page.page_name}
            </option>
          ))}
        </select>
      )}
      
      {postDestination === "group" && userGroups.length > 0 && (
        <select 
          className="ds-target-select"
          value={selectedGroup || ""}
          onChange={(e) => setSelectedGroup(e.target.value)}
        >
          <option value="">Choisir un groupe</option>
          {userGroups.map(group => (
            <option key={group.id} value={group.id}>
              {group.group_title || group.group_name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default DestinationSelector;
export {DestinationSelector};